
/* eslint-disable react-hooks/set-state-in-effect */
import { AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT } from 'constants/area-map-page-filters';
import {
  GTM_AREA_PAGE_MAP_CARD_FOURTH_CLICK,
  GTM_CLICK_HYBRID_PAGE_REMOVE_BOUNDARY,
  GTM_CLICK_AREA_PAGE_MORE_FILTERS_BUTTON,
  GTM_CLICK_AREA_PAGE_SAVE_SEARCH_BUTTON,
  GTM_VIEW_AREA_PAGE,
  GTM_CLICK_AREA_PAGE_NO_RESULTS,
} from 'constants/events';
import {
  useUserContext,
} from 'contexts/user';
import {
  CREATE_SAVED_SEARCH_MODAL,
  LOGIN_REGISTRATION_MODAL,
  SAVED_SEARCH_FILTERS_MODAL,
  TERMS_OF_USE_MODAL,
  useModalContext,
} from 'contexts/modal';
import {
  AVAILABLE_STATUS,
  NOT_AVAILABLE_OTHER_STATUS,
  Filter,
  FilterKeys,
  Sort,
  DEFAULT_HAS_IMAGE_VALUE,
} from 'contexts/preferences/listing-params/types';
import ListingParams from 'contexts/preferences/listing-params';
import { diff } from 'deep-object-diff';
import deepmerge from 'deepmerge';
import { cloneDeep } from 'lodash';
import { useRouter } from 'next/router';
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { CountryCode, CountryCodeList } from 'types/countries';
import { hasFilterDeprecationBeenAck, setFilterDeprecationAck } from 'utils/ack_filter_deprecation';
import { hasNoImageListingsFilterBeenAck, setNoImageListingsFilterAck } from 'utils/ack_no_image_listings_filter';
import { getPositionFromAddress as googleGetPositionFromAddress } from 'utils/google-maps/api/geocoder';
import { getPositionFromDescription } from 'utils/google-maps/getPositionFromDescription';
import { fetchAreaPolygons } from 'data/search/map/fetcher';
import getTargetedUrl, { TargetedUrlHelper } from 'utils/targeted-url-helper';
import { trackEvent } from 'utils/google-tag-manager';
import { getGoSearchHost, isClientSide, isServerSide } from 'utils/host-config';
import { hasDeprecatedHomeType } from 'utils/listing-query-helper';
import { isUsStateCode, ProvinceOrStateCode, provinceOrStateSlugFromCode } from 'utils/province_or_state';
import { navigateToMilitaryBaseMapView, navigateToAddressMapView, type MapViewPosition } from 'utils/redirect-to-map-view';
import { withEventTracking } from 'utils/track-event-hof';
import HybridPageView, { AreaInsightsData, HybridPageViewMethods, Pagination } from './hybrid_page_view';
import { AreaPageListingCardData } from '../area-listings/area_page_listing_card_data';
import { DEFAULT_LISTING_PARAMS_FILTER_SHARED } from 'contexts/preferences/listing-params/defaults';
import { useIsMobile } from 'hooks/use-size-class';
import { AddressType, SingleAddress, type AreaPageListing } from '@zoocasa/go-search';
import { useShowQuebecPopup } from 'hooks/use-quebec-popup';
import { useSearchResultClick } from 'hooks/use-search-result-click';
import { useCaptureLastSearch } from 'hooks/use-capture-last-search';
import { getAreaLocationFilter } from 'components/pages/area-listings/util/area-location-filter';
import { AREA_PAGE_IGNORE_PROFILE_SETTINGS_IMAGELESS_COOKIE_NAME, MLML_AGENT_COOKIE_NAME } from 'constants/cookies';
import Cookies from 'js-cookie';
import { IGNORED_FILTER_PROPERTIES } from 'constants/filter';
import { usePreferencesContext, useSavedListingContext } from 'contexts';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';
import { locationsToNotUseListingModals } from 'constants/no-listing-modal-locations';
import { cleanDashedString } from 'data/addresses';
import { FavouriteDelegate } from 'components/search-es/map/ClusterAnnotationCallout';
import { PROPERTY_FAVOURITED_SOURCE_MAP_PIN } from '@bedrock/analytics';
import { GeoSearchFilter } from 'data/search/map/types';
import { getSortBy } from 'utils/sort';
import { areMapBoundsUsableForSearch, calculateCenterPoint, getAreaClusterPrecisionFromZoom, getGeohashPrecisionFromZoom, getGeohashPrecisionFromZoomMobile, getOptimalZoomLevelForHybridPage } from 'components/search-es/geo_helper';
import { IS_MOBILE_BREAKPOINT } from 'hooks/use-size-class';
import { SearchApi } from 'data/search/api';
import { getListingsV2MapAreaSlug } from 'data/search/map/listings-v2-map-area-slug';
import { createDelayedExecution } from 'components/search-es/delay';
import { MapState } from 'components/search-es/search_page_controller';

/** Hybrid map refetch debounce (search uses 250ms). Trial: lower delay to reduce “pins then readjust” after zoom; revert or retune if requests get noisy. */
const HYBRID_MAP_REFRESH_DEBOUNCE_MS = 250;
import { getAcceptedTermsByUserFromCookies, isListingVisibleToUser, isVOWProvider } from 'utils/compliance';
import { getHideSquareFootage } from 'hooks/use-listings-compliance';
import { useQuery } from '@tanstack/react-query';
import { MAP_PAGE_CONSTANTS } from 'constants/pagination';
import { LISTING_TYPE, LOGIN_REQUIRED_TYPE, TERMS_OF_USE_REQUIRED_TYPE, MapListingCardType, CompliancyDelegateType } from 'components/map-listing-card';
import { getTenantById, TenantIds, type TenantId } from 'tenants';
import { getTenantFiltersConfig } from '@tenants/utils/configs';
import { useAreaPageObservability } from 'hooks/useAreaPageObservability';
import { ListingObservabilityService } from 'observability/services/listing-observability';

import type { ListingCardData } from 'components/listing-card';
import type { PartialDeep } from 'type-fest';
import type { AddressViewModel, HybridPageViewModel, MilitaryBaseViewModel } from './hybrid_page_view_model';
import type { Bounds, LatLngPoint } from 'components/search-es/types';
import type { MapPageCluster, MapPageListing } from '@zoocasa/go-search';
import type { Precision } from 'components/search-es/geo_helper';
import { assignPinDisplayModes } from 'utils/map/pin-display-mode';
import { getMapPinLimits } from 'hooks/use-map-pin-limits';
import { boundaryListingToMapPageListing } from 'domain/map-pin/boundary-listing-adapter';
import { BoundaryListingCardData } from 'domain/map-pin/boundary-listing-card-data';
import type { DisplayablePin } from 'domain/map-pin/map-pin.types';
import { MAX_PIN_OFFSET } from 'data/search/map/pin-fetcher';
import { PaginationMode } from 'components/control/pagination-nav';

/**
 * Query param used by the hybrid page to deep-link a pin-mode page number.
 * Page 1 is implicit (no param present) so the canonical URL doesn't carry
 * `?page=1` after a reset.
 */
const PIN_PAGE_QUERY_PARAM = 'page';

const readPinPageFromQueryValue = (value: string | string[] | undefined): number => {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== 'string') return 1;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 1) return 1;
  return Math.floor(parsed);
};


//#region Types
export interface HybridPageControllerProps {
  viewModel: HybridPageViewModel<AddressViewModel | MilitaryBaseViewModel>;
  isMobileListView: boolean;
  setIsMobileListView: (isMobileListView: boolean) => void;
  tenantId: TenantId;
}
//#endregion

const areaPageListingToListingCardData = (listing: AreaPageListing) => (new AreaPageListingCardData(listing));



/** Memoized wrapper around the AreaListingsPageView component */
const PageView = memo(HybridPageView);

const HybridPageController = (props: HybridPageControllerProps) => {
  const { viewModel: {
    pagination: {
      page, count, total, size,
    },
    heading,
    citySlug,
    areaGuideData,
    expandGuidesByDefault,
    internalLinks,
    seoLinks,
    listings,
    nextPageCursor,
    myLinkMyLead = false,
    isCrawler = false,
    mapkitSnapshotUrl,
    missingAddress,
  }, isMobileListView, setIsMobileListView, tenantId } = props;

  const isMilitaryBase = 'militaryBase' in props.viewModel;

  const viewModel = props.viewModel;
  
  const [listingsData, setListingsData] = useState<ListingCardData[]>(() => 
    listings.map((listing: AreaPageListing) => areaPageListingToListingCardData(listing))
  );
  
  const [currentPageCursor, setCurrentPageCursor] = useState<string>(''); // Empty string for page 1
  const [nextPageCursorState, setNextPageCursorState] = useState<string | undefined>(nextPageCursor);
  const [previousPageCursor, setPreviousPageCursors] = useState<string[]>([]); // Stack for prev navigation
  const [paginationData, setPaginationData] = useState<Pagination>({ page: page + 1, size, count, total });
  const listingsAbortController = useRef<AbortController | null>(null);

  const { listingParams, refreshCurrentLocationFilter } = usePreferencesContext();
  const isMobile = useIsMobile();
  const [clusters, setClusters] = useState<MapPageCluster[]>([]);
  const [displayablePins, setDisplayablePins] = useState<DisplayablePin[]>([]);
  const [visiblePinIds, setVisiblePinIds] = useState<Set<number> | null>(null);
  const [isMapLoading, setIsMapLoading] = useState(false);
  const mapRef = useRef<HybridPageViewMethods | null>(null);

  // Listings container, we need to scroll to the top when user paginates
  const listingsContainerRef = useRef<HTMLDivElement>(null);

  // Scrolls both the listings container (when map is visible) and the window (when map is hidden via "Hide Map")
  const scrollListingsToTop = useCallback((containerRef: React.RefObject<HTMLDivElement>) => {
    containerRef.current?.scrollTo({ top: 0 });
    window.scrollTo({ top: 0 });
  }, []);
  
  const clustersAbortController = useRef<AbortController | null>(null);
  const pinsAbortController = useRef<AbortController | null>(null);
  const pinsRequestId = useRef(0);
  const searchApi = useMemo(() => SearchApi.create(getGoSearchHost(isServerSide()), false), []);

  // Handle properties specific to each view model type
  const requestedAddress = isMilitaryBase ? undefined : (viewModel as HybridPageViewModel<AddressViewModel>).requestedAddress;
  const electedAddress: SingleAddress = isMilitaryBase ? undefined : (viewModel as HybridPageViewModel<AddressViewModel>).electedAddress;
  const breadcrumbs = isMilitaryBase ? [] : (viewModel as HybridPageViewModel<AddressViewModel>).breadcrumbs;
  const militaryBase = isMilitaryBase ? (viewModel as HybridPageViewModel<MilitaryBaseViewModel>).militaryBase : undefined;
  const militaryPath = isMilitaryBase ? (viewModel as HybridPageViewModel<MilitaryBaseViewModel>).militaryPath : undefined;

  // Determine if fallback occurred (requested city has no listings, so we show province/state listings)
  const isFallbackAreaPage = !isMilitaryBase && requestedAddress?.slug !== electedAddress?.slug;

  /** When SSR falls back to province, elected becomes province — map/pins should still use requested city/neighbourhood. */
  const electedAddressForMap = useMemo((): SingleAddress | undefined => {
    if (!electedAddress || isMilitaryBase || !requestedAddress || !isFallbackAreaPage) {
      return electedAddress;
    }
    if (
      requestedAddress.type !== AddressType.ADDRESS_TYPE_SUB_DIVISION &&
      requestedAddress.type !== AddressType.ADDRESS_TYPE_NEIGHBOURHOOD
    ) {
      return electedAddress;
    }
    return SingleAddress.fromPartial({
      ...electedAddress,
      addressType: requestedAddress.type,
      slug: requestedAddress.slug ?? electedAddress.slug,
      neighbourhood: requestedAddress.neighbourhood?.name ?? electedAddress.neighbourhood,
      subDivision: requestedAddress.subDivision?.name ?? electedAddress.subDivision,
    });
  }, [electedAddress, requestedAddress, isFallbackAreaPage, isMilitaryBase]);

  /** Map polygon/center and Map prop — URL scope when fallback elected a broader area. */
  const addressForMapUi = electedAddressForMap ?? electedAddress;

  const optimalZoom = electedAddress
    ? getOptimalZoomLevelForHybridPage(electedAddressForMap ?? electedAddress)
    : 11;
  const [mapState, setMapState] = useState<MapState>({ ready: false, boundingRegion: null, zoom: optimalZoom });
  const mapZoom = optimalZoom;
  /** Desktop "Hide Map" / full-width list — map may report invalid bounds or no visible pins; keep last listing set. */
  const [isHybridDesktopListFullWidth, setIsHybridDesktopListFullWidth] = useState(false);

  const { openModal } = useModalContext();
  const { user, isAuthenticated, siteLocation } = useUserContext();
  const { isSavedListing, addSavedListing, removeSavedListing } = useSavedListingContext();
  const { t } = useTranslation(Namespaces.COMMON);
  const router = useRouter();
  const { push, query } = router;
  const tenant = getTenantById(tenantId);
  const tenantFilters = getTenantFiltersConfig(tenant ?? getTenantById(TenantIds.ZOOCASA));
  const filterByCountryCode: CountryCode | undefined = tenantFilters?.countryCode ?? (electedAddress?.countryCode as CountryCode | undefined);
  const useLayoutV2 = tenant?.features?.UseNewHybridPageDesign ?? false;
  const useBuildingGroupedPins = tenant?.features?.UseBuildingGroupedPins ?? false;

  // Pin-mode page number, sourced from `?page=` on first render and then driven
  // by setPinPageNumber. Stays at 1 (and the param stays out of the URL) for
  // tenants/pages that aren't using building-grouped pins.
  const [pinPage, setPinPage] = useState<number>(() => readPinPageFromQueryValue(router.query[PIN_PAGE_QUERY_PARAM]));
  // Keep a ref so the pin fetch closure (recreated rarely, see useCallback deps)
  // can read the latest page without forcing every callback to re-bind.
  const pinPageRef = useRef(pinPage);
  pinPageRef.current = pinPage;
  // Flips true after the first pin fetch resolves with the URL-supplied page.
  // Used to decide whether map pan/zoom should reset back to page 1: we only
  // want to reset *user-driven* viewport changes, not the initial map mount.
  const hasFetchedInitialPin = useRef(false);

  // Track whether initial boundary API call has completed
  const [hasLoadedBoundaryData, setHasLoadedBoundaryData] = useState(false);

  // Separate flag for pin data — hasLoadedBoundaryData is also set by the boundary
  // listings path (getListingsWithinMapBoundsAndArea) which runs before the map is ready,
  // so it cannot be used to gate the loading state when building-grouped pins are enabled.
  const [hasLoadedPinData, setHasLoadedPinData] = useState(false);

  // For observability: use 0 when fallback occurred, since the requested city has no listings
  // Otherwise use the actual count from the requested area
  const observabilityListingCount = isFallbackAreaPage ? 0 : paginationData.count;

  // Track area page load for observability
  // Wait for boundary API data to be ready before tracking
  // Use requestedAddress.subDivision.slug for city tracking to ensure we track the requested city
  // even when fallback occurs (electedAddress.slug may be province/state after fallback).
  // Province/state and country codes are still correct from electedAddress even after fallback.
  // Use 0 for listingCount when fallback occurred, since the requested city has no listings.
  useAreaPageObservability({
    citySlug: requestedAddress?.subDivision?.slug ?? electedAddress?.slug ?? '',
    provinceOrState: electedAddress?.provinceOrState ?? '',
    country: electedAddress?.countryCode ?? '',
    listingCount: observabilityListingCount, // Use 0 when fallback occurred, otherwise use client-side count
    pageType: 'hybrid',
    tenant: tenant ?? getTenantById(TenantIds.ZOOCASA),
    isDataReady: hasLoadedBoundaryData, // Wait for boundary API
  });

  const sourceFilter = isMilitaryBase ? militaryPath?.filter : requestedAddress?.filter;
  const sourceSort = isMilitaryBase ? militaryPath?.sort : requestedAddress?.sort;
  
  // Cleanup abort controllers on unmount
  useEffect(() => {
    return () => {
      listingsAbortController.current?.abort();
      clustersAbortController.current?.abort();
      pinsAbortController.current?.abort();
    };
  }, []);

  // Initialize default filters and sort based on military or area page
  // TODO: Potentially move this to getServerSideProps (so that logic is pregenerated on server and will be better for SEO)
  useEffect(() => {
    // sourceFilter carries only the URL's SEO filters (status/home type/price) — never the
    // location — and DEFAULT_LISTING_PARAMS_FILTER_SHARED blanks slug/areaName. Without the
    // area re-applied here, listingParams identifies no area at all, and every consumer that
    // persists it (captureLastSearch, the listing-params cookie, saved searches) records the
    // Toronto/Tampa default instead of the area on screen.
    const areaLocationFilter = getAreaLocationFilter({ requestedAddress, electedAddress, militaryBase });

    if (sourceFilter) {
      const consolidatedFilter = deepmerge(DEFAULT_LISTING_PARAMS_FILTER_SHARED, sourceFilter as Filter);
      listingParams.setFilter({ ...consolidatedFilter, ...areaLocationFilter });
    } else {
      listingParams.setFilter({ ...DEFAULT_LISTING_PARAMS_FILTER_SHARED, ...areaLocationFilter });
    }

    if (sourceSort) {
      listingParams.setSort(sourceSort);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const hasListings = paginationData.count > 0;
  const showDisclaimer = (isMilitaryBase || electedAddress.countryCode === CountryCodeList.UNITED_STATES) && hasListings;
  /** listings_v2 keyword alignment: composite URL slugs (e.g. milton-on) are mapped to subdivision / neighbourhood / province slugs. */
  const listingsV2MapAreaSlug = useMemo(() => {
    if (isMilitaryBase) {
      return militaryBase?.slug;
    }
    if (!electedAddress) {
      return undefined;
    }
    return getListingsV2MapAreaSlug(electedAddressForMap ?? electedAddress, requestedAddress);
  }, [isMilitaryBase, militaryBase?.slug, electedAddress, electedAddressForMap, requestedAddress]);

  /** listings_v1 (clusters/boundary) expects the full composite URL slug (e.g. milton-on, toronto-on). */
  const compositeAreaSlug = useMemo(() => {
    if (isMilitaryBase) {
      return militaryBase?.slug;
    }
    return (electedAddressForMap ?? electedAddress)?.slug?.trim().toLowerCase();
  }, [isMilitaryBase, militaryBase?.slug, electedAddress, electedAddressForMap]);

  const handleVisiblePinIdsChanged = useCallback((ids: Set<number>) => {
    setVisiblePinIds(ids);
  }, []);

  const viewportFilteredListings = useMemo(() => {
    if (isHybridDesktopListFullWidth) {
      return null;
    }
    if (!useBuildingGroupedPins || displayablePins.length === 0 || !visiblePinIds) return null;
    const listings: ListingCardData[] = [];
    for (const dp of displayablePins) {
      const repId = dp.pin.representative?.id;
      if (repId != null && visiblePinIds.has(repId) && dp.pin.representative) {
        listings.push(new BoundaryListingCardData(dp.pin.representative));
      }
    }
    return {
      listings,
      visibleCount: listings.length,
      totalCount: displayablePins.length,
    };
  }, [useBuildingGroupedPins, displayablePins, visiblePinIds, isHybridDesktopListFullWidth]);

  const listingsForGrid = useMemo(
    () => (isMobile && isMobileListView)
      ? listingsData
      : (viewportFilteredListings?.listings ?? listingsData),
    [viewportFilteredListings, listingsData, isMobile, isMobileListView]
  );

  const isStatusAvailable = listingParams.filter.status === AVAILABLE_STATUS;
  const showGuides = !isMilitaryBase && (isStatusAvailable || hasListings) && !isFallbackAreaPage && areaGuideData !== null;

  // Hide map for province/state/country *URLs*; when listings elected a province after city fallback, URL is still city — show map.
  const isProvinceOrCountryAddress =
    !isMilitaryBase &&
    (requestedAddress != null
      ? requestedAddress.type === AddressType.ADDRESS_TYPE_PROVINCE_OR_STATE ||
        requestedAddress.type === AddressType.ADDRESS_TYPE_COUNTRY
      : electedAddress?.addressType === AddressType.ADDRESS_TYPE_PROVINCE_OR_STATE ||
        electedAddress?.addressType === AddressType.ADDRESS_TYPE_COUNTRY);

  // In building-grouped pins mode the side panel is driven entirely by the pins fetch,
  // which is capped at maxPins. Show the loading state from the very first render (SSR
  // included) until that first fetch resolves, rather than flashing the unlimited SSR
  // boundary listings/count and then "readjusting" down to the limited pin view.
  // Exclusions:
  //  - crawlers keep the SSR listings for SEO and never run the client pin fetch
  //  - mobile list view doesn't mount the map, so pins never load there — forcing a
  //    perpetual skeleton would be wrong.
  const pinsWillDriveListings = useBuildingGroupedPins && !isProvinceOrCountryAddress && !isCrawler && (!isMobile || !isMobileListView);
  const isListingsLoading = pinsWillDriveListings && !hasLoadedPinData;

  let areaOverviewTitle: string | undefined;
  let areaBlurb: string | undefined;
  let areaBlurbHeading: string | undefined;
  let areaNamedContent: string[] | undefined;

  // areaName + insights power the always-on Area FAQ, so they are computed
  // independently of showGuides (which gates the richer AreaGuides block).
  // City/neighbourhood areas get the province/state suffix (e.g. "Toronto, ON");
  // province and country areas stand alone. provinceOrState on electedAddress is
  // a lowercase code (e.g. "on"), so it is upper-cased for display.
  const provinceOrStateAbbr = electedAddress?.provinceOrState?.toUpperCase();
  const subArea = requestedAddress?.neighbourhood?.name || requestedAddress?.subDivision?.name;
  const areaName: string | undefined = subArea
    ? (provinceOrStateAbbr ? `${subArea}, ${provinceOrStateAbbr}` : subArea)
    : (requestedAddress?.provinceOrState?.name || requestedAddress?.country?.name || electedAddress?.label);
  const areaInsightsData: AreaInsightsData | undefined = areaGuideData?.areaInsightsData;

  if (showGuides) {
    areaOverviewTitle = generateAreaOverviewTitle(electedAddress);
    areaBlurb = areaGuideData?.areaBlurb;
    areaBlurbHeading = areaGuideData?.areaBlurbHeading;
    areaNamedContent = areaGuideData?.areaNamedContent;
  }

  const showFilterDeprecationWarningInitialState = (filter: PartialDeep<Filter>) => () => isClientSide() && !hasFilterDeprecationBeenAck() && hasDeprecatedHomeType(filter);
  const showNoImageListingsFilterWarningInitialState = (hasImageFilter: boolean = DEFAULT_HAS_IMAGE_VALUE) => () => isClientSide() && !hasNoImageListingsFilterBeenAck() && hasImageFilter;

  const [showFilterDeprecationWarning, setShowFilterDeprecationWarning] = useState(showFilterDeprecationWarningInitialState(listingParams.filter));
  const [showNoImageListingsFilterWarning, setShowNoImageListingsFilterWarning] = useState(showNoImageListingsFilterWarningInitialState(listingParams.filter.hasImage));

  // Generate message for missing address redirect (when user navigates to a non-existent address page)
  // The missingAddress prop is set by the server-side props from a cookie set by the middleware
  const missingAddressMessage = useMemo(() => {
    if (!missingAddress) return undefined;
    const electedAddressLabel = !isMilitaryBase 
      ? ([electedAddress.neighbourhood, electedAddress.subDivision, electedAddress.provinceOrState]
        .filter(Boolean)
        .join(', ') || electedAddress.country)
      : '';
    return t(LOCALE_COMMON_PATHS.AREA_PAGE_SUBHEADING_MISSING_ADDRESS, {
      missingAddress,
      electedArea: electedAddressLabel,
    });
  }, [missingAddress, electedAddress, isMilitaryBase, t]);

  // Track listing view failure when redirected from non-existent listing
  const hasTrackedMissingListingRef = useRef(false);
  useEffect(() => {
    if (hasTrackedMissingListingRef.current || !missingAddress) return;

    hasTrackedMissingListingRef.current = true;

    ListingObservabilityService.trackViewFailure({
      listingData: { id: 0, address: missingAddress },
      error: 'Listing does not exist or has been deleted',
      errorCategory: 'not_found',
    });
  }, [missingAddress]);

  const [noListingsInAreaMessage, setNoListingsInAreaMessage] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (isFallbackAreaPage) {
      const requestedAddressLabel = [requestedAddress.neighbourhood?.name, requestedAddress.subDivision?.name, requestedAddress.provinceOrState?.name]
        .filter(Boolean)
        .join(', ');
      const electedAddressLabel = [electedAddress.neighbourhood, electedAddress.subDivision, electedAddress.provinceOrState]
        .filter(Boolean)
        .join(', ') || electedAddress.country;
      let grammar_prefix = '';
      if (electedAddressLabel == 'USA') {
        grammar_prefix = 'the ';
      }

      trackEvent(GTM_CLICK_AREA_PAGE_NO_RESULTS);

      /* eslint-disable react-hooks/set-state-in-effect */
      if (requestedAddressLabel && requestedAddressLabel.length > 0) {
        setNoListingsInAreaMessage(`0 Listings Found / We couldn't find any real estate listings in ${requestedAddressLabel}. Here are some listings in ${grammar_prefix}${electedAddressLabel}`);
      } else {
        setNoListingsInAreaMessage(`0 Listings Found / We couldn't find listings matching the criteria but here are some in ${grammar_prefix}${electedAddressLabel}...`);
      }
      /* eslint-enable react-hooks/set-state-in-effect */
    }
  }, [isFallbackAreaPage, requestedAddress, electedAddress]);

  const internalLinksHeading = useIsMobile() ? 'Explore More Listings' : '';

  // Remove missingAddress query parameter from URL after it has been read 
  if (isClientSide() && missingAddress) {
    const url = new URL(window.location.href);
    url.searchParams.delete('missingAddress');
    const cleanUrl = url.pathname + url.search;
    window.history.replaceState({ ...window.history.state, as: cleanUrl, url: cleanUrl }, '', cleanUrl);
  }

  // we only want to run this once to restore the scroll position after the component's initial render
  useEffect(() => {
    trackEvent(GTM_VIEW_AREA_PAGE);

    // We set this when user wants to temporarily disable (ignore) that user setting here in area page (instead of user profile)
    // ignoreProfileImagelessSetting is mainly for server side to detect when not to use the filter 'hasImage'
    const ignoreProfileImagelessSetting = Cookies.get(AREA_PAGE_IGNORE_PROFILE_SETTINGS_IMAGELESS_COOKIE_NAME);
    // We can clear it in client-side
    if (ignoreProfileImagelessSetting) Cookies.remove(AREA_PAGE_IGNORE_PROFILE_SETTINGS_IMAGELESS_COOKIE_NAME);
  }, []);

  const captureLastSearch = useCaptureLastSearch();
  const showQuebecPopup = useShowQuebecPopup();
  const hasQuebecContent = !isMilitaryBase && requestedAddress.provinceOrState?.slug === provinceOrStateSlugFromCode('qc');

  useEffect(() => {
    showQuebecPopup(hasQuebecContent, 'area');
  }, [hasQuebecContent, showQuebecPopup]);

  // Reset pagination to page 1
  const resetPagination = useCallback(() => {
    setCurrentPageCursor('');
    setPreviousPageCursors([]);
    setPaginationData(prev => ({ ...prev, page: 1 }));
  }, []);

  // Sync `?page=` to the current pinPage. Page 1 is canonical and has no param.
  //
  // We deliberately avoid `router.replace` here: the page is mounted with
  // `key={router.asPath}` (see src/pages/area-listings/[...areaPath].tsx), so
  // any route change — even a shallow one — remounts this controller. On the
  // remount, `router.query.page` may not be hydrated yet (router.isReady is
  // briefly false), the `useState` initializer reads `undefined`, defaults to
  // page 1, and this effect then strips the param off the URL — which the user
  // observes as "page click immediately reverts to page 1".
  //
  // window.history.replaceState mutates the URL bar in place without a Next.js
  // navigation, so asPath stays stable and no remount happens. This mirrors
  // updateUrlWithFiltersAndSort below, which uses the same trick for filters.
  useEffect(() => {
    if (!useBuildingGroupedPins) return;
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    const currentString = url.searchParams.get(PIN_PAGE_QUERY_PARAM);
    const desiredString = pinPage > 1 ? String(pinPage) : null;
    if (currentString === desiredString) return;
    if (desiredString === null) {
      url.searchParams.delete(PIN_PAGE_QUERY_PARAM);
    } else {
      url.searchParams.set(PIN_PAGE_QUERY_PARAM, desiredString);
    }
    const cleanUrl = url.pathname + url.search;
    window.history.replaceState({ ...window.history.state, as: cleanUrl, url: cleanUrl }, '', cleanUrl);
  }, [pinPage, useBuildingGroupedPins]);

  //Fetch listings within map bounds and area
  const getListingsWithinMapBoundsAndArea = useCallback(async (bounds: Bounds | null, zoom: number | null, pageCursor: string, listingParams: ListingParams, areaSlug?: string, resetPage: boolean = false) => {
    if (isCrawler)
      return;

    // Hybrid area pages must not call boundary APIs without area_slug (go-search applies no area filter when omitted).
    if (!areaSlug?.trim()) {
      return;
    }

    listingsAbortController?.current?.abort();
    listingsAbortController.current = new AbortController();

    try {
      const sort = listingParams.sort;
      const originalFilter: GeoSearchFilter = { 
        ...cloneDeep(listingParams.filter), 
        countryCode: filterByCountryCode,
      };

      const useMobilePrecision = window.innerWidth < IS_MOBILE_BREAKPOINT;
      const adjustedZoom = useMobilePrecision ? zoom : Math.floor(zoom);
      const getPrecisionFn = useMobilePrecision ? getGeohashPrecisionFromZoomMobile : getGeohashPrecisionFromZoom;
      const precision = useMobilePrecision ? getPrecisionFn(adjustedZoom) : getPrecisionFn(adjustedZoom) + 1;
      
      const boundaryResponse = await searchApi.searchListingsInBoundary(
        bounds,
        precision as Precision,
        pageCursor,
        originalFilter,
        getSortBy(sort),
        listingsAbortController.current.signal,
        size,
        areaSlug
      );
      
      const newListings = boundaryResponse.listings.map((listing: AreaPageListing) => areaPageListingToListingCardData(listing));

      // Optimization, only set clusters if they've changed, avoiding unnecessary rerenders
      setListingsData(prevListings => {
        if (prevListings.length === newListings.length && 
            prevListings.every((item, i) => item.id === newListings[i].id)) {
          return prevListings; 
        }
        return newListings;
      });
      setNextPageCursorState(boundaryResponse.nextPage || null);
      setPaginationData(prev => ({
        page: !resetPage ? prev.page : 1,
        size: prev.size,
        count: boundaryResponse.totalCount,
        total: boundaryResponse.totalPages ?? 1,
      }));
      
      // Mark boundary data as loaded for observability tracking
      setHasLoadedBoundaryData(true);
    } catch (error) {
      const err = error as { name?: string } | undefined;
      if (err?.name === 'AbortError') {
        console.debug('fetch listings within boundary request was aborted');
      } else {
        console.error('failed to get listings within boundary request', error);
      }
    } finally {
      listingsAbortController.current = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [electedAddress, size, filterByCountryCode]);

  const getListingsWithinMapBoundsAndAreaRef = useRef(getListingsWithinMapBoundsAndArea);
  getListingsWithinMapBoundsAndAreaRef.current = getListingsWithinMapBoundsAndArea;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getClusterWithinAreaCallback = useCallback(getClustersWithinArea, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getPinsWithinAreaCallback = useCallback(getPinsWithinArea, []);

  const refreshPageData = useCallback(() => {
    // Province/country pages have no map on desktop — don't use map bounds for data.
    // On mobile, when the user has switched to map view, treat it like a normal page
    // and use the real map bounds so pins/clusters load within the visible area.
    const mobileMapViewActive = isProvinceOrCountryAddress && isMobile && !isMobileListView;
    const useMapState = !isProvinceOrCountryAddress || mobileMapViewActive;
    const mapStateZoom = useMapState ? mapState.zoom : null;
    const mapStateBoundingRegion = useMapState ? mapState.boundingRegion : null;
    resetPagination();

    const mapReady = mapStateBoundingRegion != null && mapStateZoom != null;
    // When building-grouped pins are enabled on a page with a map, pins are the sole
    // data source for the listing strip — skip the boundary listings call entirely.
    // Province/country pages without a visible map still need the boundary path.
    const listingsComeFromPinsOnly = useBuildingGroupedPins && (!isProvinceOrCountryAddress || mobileMapViewActive);

    if (mapReady) {
      const center = calculateCenterPoint(mapState.boundingRegion);
      if (useBuildingGroupedPins) {
        if (listingsV2MapAreaSlug?.trim()) {
          // pinPageRef is the source of truth: the URL→state hydration on first
          // mount sets it to ?page=N, and viewport resets/page-jumps update it
          // before this fires. The pin fetch then clamps to maxReachablePage.
          getPinsWithinAreaCallback(listingsV2MapAreaSlug, mapState.zoom, center, listingParams, mapState.boundingRegion, pinPageRef.current);
        } else {
          setClusters([]);
          setDisplayablePins([]);
          setVisiblePinIds(null);
          setListingsData([]);
          setNextPageCursorState(null);
          setPaginationData(prev => ({ ...prev, count: 0, total: 1, page: 1 }));
        }
      } else if (compositeAreaSlug?.trim()) {
        getClusterWithinAreaCallback(compositeAreaSlug, mapState.zoom, center, listingParams, mapState.boundingRegion);
      } else {
        setClusters([]);
      }
    }

    if (!listingsComeFromPinsOnly) {
      getListingsWithinMapBoundsAndArea(mapStateBoundingRegion, mapStateZoom, '', listingParams, compositeAreaSlug, true);
    }
    
  }, [mapState.boundingRegion, mapState.zoom, isProvinceOrCountryAddress, isMobile, isMobileListView, resetPagination, listingsV2MapAreaSlug, compositeAreaSlug, listingParams, getClusterWithinAreaCallback, getPinsWithinAreaCallback, getListingsWithinMapBoundsAndArea, useBuildingGroupedPins]);

  const purgeAndRefreshPageData = useCallback(() => {

    // Reset clusters, map and pagination. Refetch listings.
    setClusters([]);
    setDisplayablePins([]);
    setVisiblePinIds(null);
    setHasLoadedPinData(false);
    pinsAbortController.current?.abort();
    mapRef.current?.clearAnnotations?.();
    // Filter/sort/auth changes invalidate the current pin result set entirely,
    // so the user goes back to page 1 (and the URL ?page= param is dropped).
    setPinPage(1);
    refreshPageData();
  }, [refreshPageData]);


  /**
   * Update URL with filter and sort state without reloading page
   */
  const updateUrlWithFiltersAndSort = useCallback((filters: Filter, sort: Sort, fallbackSlug: string = '') => {
    const currentUrl = `${window.location.origin}${window.location.pathname}`;
    
    const targetedUrlConfig: TargetedUrlHelper = {
      url: currentUrl,
      filters,
      sort,
      pageNumber: 1, // page number is a required parameter, however we don't use it because we have cursor based pagination
      fallbackSlug,
    };
  
    const targetedPath = getTargetedUrl(targetedUrlConfig);
    
    const cleanUrl = targetedPath.pathname + targetedPath.search;
    window.history.replaceState(
      { ...window.history.state, as: cleanUrl, url: cleanUrl },
      '',
      cleanUrl
    );
  }, []);

  const onFiltersChanged = useCallback((changedFilters: PartialDeep<Filter>, changedFilter?: string) => {
    // Clean up any unwanted properties that trigger a filter change
    const sanitizedFilter = Object.keys(changedFilters)
      .filter(key => !IGNORED_FILTER_PROPERTIES.includes(key as FilterKeys))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: changedFilters[key as FilterKeys],
        };
      }, {} as PartialDeep<Filter>);

    const consolidatedFilter = deepmerge(listingParams.filter, sanitizedFilter);
    // We need to merge the consolidated filters with the default filter values since in a lot of places the code expects
    // all filter values to be set even if they are not relevant to the component accessing it.
    const listingParamsFilter = deepmerge(DEFAULT_LISTING_PARAMS_FILTER_SHARED, consolidatedFilter as Filter);
    const cookieFiltersClone: Filter = cloneDeep(listingParams.filter);
    const listingParamsFilterClone: Filter = cloneDeep(listingParamsFilter);
    IGNORED_FILTER_PROPERTIES.forEach(key => {
      delete cookieFiltersClone[key];
      delete listingParamsFilterClone[key];
    });

    const filterDiff = diff(cookieFiltersClone, listingParamsFilterClone) as Filter;

    if (filterDiff?.status) {
      const updatedStatus = filterDiff.status as string;
      if (updatedStatus === AVAILABLE_STATUS) {
        trackEvent(AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT['active']);
      } else if (updatedStatus === NOT_AVAILABLE_OTHER_STATUS) {
        trackEvent(AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT['expired']);
      }
    }

    // If user wants to temporarily turn on hasImage filter and ignore his/her user setting,
    // then we would detect a mismatch, and send a new cookie so when page loads (after the filter change),
    // we know not to use hasImage in user profile when fetching listings on server side
    if (filterDiff?.hasImage !== user?.hideImagelessListings) {
      Cookies.set(AREA_PAGE_IGNORE_PROFILE_SETTINGS_IMAGELESS_COOKIE_NAME, 'true');
    }

    if (Object.keys(filterDiff).length !== 0) {
      // This will trigger a rerender as this component is an observer for the Mobx storage and it is necessary because
      // when we navigate to the map page, we reset the smart url and go back to the /search route. That way the map component
      // depends on the listingParams to figure out the current filters
      listingParams.setFilter(listingParamsFilter as Filter);
      purgeAndRefreshPageData();
      if (user?.id && listingParams) {
        captureLastSearch(user?.id, listingParams);
      }
      refreshCurrentLocationFilter(listingParams.filter);

      updateUrlWithFiltersAndSort(consolidatedFilter as Filter, listingParams.sort);
    }

    if (changedFilter) {
      trackEvent(AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT[changedFilter]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listingParams, user?.id, sourceSort, captureLastSearch, refreshCurrentLocationFilter, mapState.boundingRegion, mapState.zoom, listingsV2MapAreaSlug, optimalZoom, getListingsWithinMapBoundsAndArea, resetPagination]);

  const onSortChanged = useCallback((newSort: Sort) => {
    if (listingParams.sort != newSort) {
      listingParams.setSort(newSort);
      captureLastSearch(user?.id, listingParams);

      updateUrlWithFiltersAndSort(listingParams.filter, newSort, isFallbackAreaPage ? electedAddress?.slug : '');


      purgeAndRefreshPageData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listingParams, captureLastSearch, user?.id, purgeAndRefreshPageData]);

  // Prev/Next pagination handlers
  const handleNextPage = useCallback(async () => {
    // Cursor next/prev is disabled for map-driven area listings when building pins are on:
    // listing rows are viewport/pin-filtered, not cursor pages (matches search_page_controller).
    if (useBuildingGroupedPins && !isProvinceOrCountryAddress) {
      return;
    }
    if (!nextPageCursorState) {
      return; // No next page available
    }
    
    if (currentPageCursor) {
      setPreviousPageCursors(prev => [...prev, currentPageCursor]);
    }
    
    setCurrentPageCursor(nextPageCursorState);
    
    // For province pages, don't use map bounds
    const bounds = !isProvinceOrCountryAddress ? mapState.boundingRegion : null;
    const zoom = !isProvinceOrCountryAddress ? (mapState.zoom || optimalZoom) : null;
    await getListingsWithinMapBoundsAndArea(bounds, zoom, nextPageCursorState, listingParams, compositeAreaSlug);
    
    setPaginationData(prev => ({ ...prev, page: prev.page + 1 }));
  
    scrollListingsToTop(listingsContainerRef);
  }, [nextPageCursorState, currentPageCursor, mapState.boundingRegion, mapState.zoom, optimalZoom, listingParams, compositeAreaSlug, getListingsWithinMapBoundsAndArea, isProvinceOrCountryAddress, scrollListingsToTop, useBuildingGroupedPins]);

  const handlePrevPage = useCallback(async () => {
    // Same as handleNextPage — no cursor pagination in building-pins map mode for area pages.
    if (useBuildingGroupedPins && !isProvinceOrCountryAddress) {
      return;
    }
    if (previousPageCursor.length === 0) {
      // Go back to page 1
      setCurrentPageCursor('');
      setPreviousPageCursors([]);
      
      const bounds = !isProvinceOrCountryAddress ? mapState.boundingRegion : null;
      const zoom = !isProvinceOrCountryAddress ? mapState.zoom || optimalZoom : null;
      await getListingsWithinMapBoundsAndArea(bounds, zoom, '', listingParams, compositeAreaSlug);
      
      setPaginationData(prev => ({ ...prev, page: 1 }));
      
      scrollListingsToTop(listingsContainerRef);
      return;
    }
    
  
    const prevCursors = [...previousPageCursor];
    const prevCursor = prevCursors.pop() || '';
    
    setPreviousPageCursors(prevCursors);
    setCurrentPageCursor(prevCursor);
    
    // Fetch previous page of listings
    const bounds = !isProvinceOrCountryAddress ? mapState.boundingRegion : null;
    const zoom = !isProvinceOrCountryAddress ? mapState.zoom || optimalZoom : null;
    await getListingsWithinMapBoundsAndArea(bounds, zoom, prevCursor, listingParams, compositeAreaSlug);
    
    setPaginationData(prev => ({ ...prev, page: prev.page - 1 }));
    
    scrollListingsToTop(listingsContainerRef);
  }, [previousPageCursor, mapState.boundingRegion, mapState.zoom, optimalZoom, listingParams, compositeAreaSlug, getListingsWithinMapBoundsAndArea, isProvinceOrCountryAddress, scrollListingsToTop, useBuildingGroupedPins]);


  // Numbered pagination handler used in pin mode (the "next/prev" handlers
  // above are no-ops here because pin pages aren't cursor-based). Updates
  // pinPage state (which the URL effect picks up) and fires a fresh fetch
  // for the new offset, then scrolls the side panel back to the top.
  const handlePinPageNumberChange = useCallback((newPage: number) => {
    if (!useBuildingGroupedPins) return;
    if (!Number.isFinite(newPage) || newPage < 1) return;
    if (newPage === pinPageRef.current) return;
    if (!listingsV2MapAreaSlug?.trim()) return;
    if (!mapState.boundingRegion || mapState.zoom == null) return;

    setPinPage(newPage);
    setHasLoadedPinData(false);
    const center = calculateCenterPoint(mapState.boundingRegion);
    getPinsWithinAreaCallback(listingsV2MapAreaSlug, mapState.zoom, center, listingParams, mapState.boundingRegion, newPage);
    scrollListingsToTop(listingsContainerRef);
  }, [useBuildingGroupedPins, listingsV2MapAreaSlug, mapState.boundingRegion, mapState.zoom, listingParams, getPinsWithinAreaCallback, scrollListingsToTop]);

  const handleDeprecationWarningButtonClicked = useCallback(() => {
    setFilterDeprecationAck(true);
    setShowFilterDeprecationWarning(false);
  }, [setShowFilterDeprecationWarning]);

  const handleNoImageListingsFilterWarningClose = useCallback(() => {
    setNoImageListingsFilterAck(true);
    setShowNoImageListingsFilterWarning(false);
  }, [setShowNoImageListingsFilterWarning]);

  const trackMapCardClick = useCallback(() => { // This one is for a secondary way to go to the map within the listing grid
    trackEvent(GTM_AREA_PAGE_MAP_CARD_FOURTH_CLICK);
    if (isMilitaryBase) {
      navigateToMilitaryBaseMapView(listingParams, militaryPath, push, siteLocation);
    } else {
      navigateToAddressMapView(listingParams, electedAddress, push, siteLocation);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openSavedSearchFiltersModal = useCallback(() => {
    openModal(SAVED_SEARCH_FILTERS_MODAL, {
      filter: listingParams.filter,
      onFiltersChanged,
      showNoImageListingsFilterWarning,
      onNoImageListingsFilterWarningClose: handleNoImageListingsFilterWarningClose,
    });
  }, [openModal, listingParams.filter, onFiltersChanged, showNoImageListingsFilterWarning, handleNoImageListingsFilterWarningClose]);

  const onMoreButtonClick = useCallback(() => {
    const handleMoreButtonClick = withEventTracking(GTM_CLICK_AREA_PAGE_MORE_FILTERS_BUTTON, openSavedSearchFiltersModal);
    handleMoreButtonClick();
  }, [openSavedSearchFiltersModal]);

  const onSaveSearchButtonClick = useCallback(() => {
    const handleSaveSearchButtonClick = withEventTracking(GTM_CLICK_AREA_PAGE_SAVE_SEARCH_BUTTON, () => {
      if (isAuthenticated) {
        const saveWithFetchedPosition = async () => { // Sets position if user lands on area page with URL
          if (listingParams.filter.slug || query?.areaPath?.[0]) {
            // TODO: In the future, move this to go-search polygon endpoint instead of google.
            const position = await getPositionFromAddress(listingParams.filter.slug || query?.areaPath?.[0]);
            const latitude = position?.latitude;
            const longitude = position?.longitude;
            if (latitude && longitude) {
              listingParams.setFilter({
                ...listingParams.filter,
                latitude,
                longitude,
              });
              openModal(CREATE_SAVED_SEARCH_MODAL, { query: { ...listingParams, filter: { ...listingParams.filter, boundary: null, latitude, longitude }}});
            }
          } else if (militaryBase) {
            const position = await getPositionFromAddress(militaryBase.slug);
            const latitude = position?.latitude;
            const longitude = position?.longitude;
            if (latitude && longitude) {
              listingParams.setFilter({
                ...listingParams.filter,
                latitude,
                longitude,
              });
              openModal(CREATE_SAVED_SEARCH_MODAL, { query: { ...listingParams, filter: { ...listingParams.filter, boundary: null, latitude, longitude }}});
            }
          }
        };
        saveWithFetchedPosition();
      } else {
        openModal(LOGIN_REGISTRATION_MODAL);
      }
    });
    handleSaveSearchButtonClick();
  }, [isAuthenticated, listingParams, query?.areaPath, militaryBase, openModal]);
  const onSearchResultClick = useSearchResultClick(true);

  const handleMapIconClick = withEventTracking(GTM_CLICK_HYBRID_PAGE_REMOVE_BOUNDARY, () => {
    // Preserve the exact map viewport the user is currently looking at instead of
    // re-geocoding the area, which jumps the center to a geocoded point and resets
    // the zoom to a fixed level. When the map isn't ready (e.g. province/country
    // pages with no visible map), position stays undefined and the navigation
    // helpers fall back to geocoding as before.
    let position: MapViewPosition | undefined;
    if (mapState.boundingRegion && mapState.zoom != null) {
      const center = calculateCenterPoint(mapState.boundingRegion);
      position = { latitude: center.lat, longitude: center.lng, zoom: Math.round(mapState.zoom) };
    }
    if (isMilitaryBase) {
      navigateToMilitaryBaseMapView(listingParams, militaryPath, push, siteLocation, position);
    } else {
      // Use addressForMapUi (not the raw electedAddress): on a fallback area page
      // electedAddress is the province (subDivision empty), which would geocode the
      // search bar/center to the province. addressForMapUi re-injects the requested
      // city, matching what the map already displays.
      navigateToAddressMapView(listingParams, addressForMapUi, push, siteLocation, position);
    }
  });


  let showsMyLinkMyLeadCreate = false;

  if (myLinkMyLead) {
    showsMyLinkMyLeadCreate = !!Cookies.get(MLML_AGENT_COOKIE_NAME);
  }

  const compliancyDelegate: CompliancyDelegateType = {
    getMapListingCardType: function (listing: MapPageListing): MapListingCardType {
      const isVow = isVOWProvider(listing.providerId);
      const isPrivate = isVow;
      const isPrivateToUser = !isAuthenticated && isPrivate;
      if (isPrivateToUser) {
        return LOGIN_REQUIRED_TYPE;
      }

      const { userBasedTerms, browserBasedTerms } = getAcceptedTermsByUserFromCookies(user?.id);
      const isVisible = isListingVisibleToUser(
        isPrivateToUser,
        listing.providerId,
        browserBasedTerms,
        userBasedTerms
      );

      if (isVisible) {
        return LISTING_TYPE;
      }

      return TERMS_OF_USE_REQUIRED_TYPE;
    },
    mustShowProviderLogo: function (listing: MapPageListing): boolean {
      const components = listing.address.split(',').map(component => component.trim());
      const province = components[2] || '';
      return isUsStateCode(province?.toLowerCase() as ProvinceOrStateCode);
    },
    shouldOpenAsModal: function (listing: MapPageListing): boolean {
      if (isMobile) {
        return false;
      }
      const components = listing.address.split(',').map(component => component.trim());
      const province = components[2] || '';
      return !locationsToNotUseListingModals.includes(province);
    },
    hideSquareFootage: function (listing: MapPageListing): boolean {
      return getHideSquareFootage(listing.providerId, listing.standardStatus);
    },
  };

  async function getPositionFromAddress(address: string) {
    const isUs = electedAddress?.countryCode === CountryCodeList.UNITED_STATES;
    try {
      const position = await getPositionFromDescription(address, isUs);
      if (position) {
        return position;
      }
    } catch (error) {
      console.error('Places autocomplete error, falling back to geocoder:', error);
    }

    try {
      const position = await googleGetPositionFromAddress(address);
      if (position) {
        return {
          latitude: position.geometry.location.lat(),
          longitude: position.geometry.location.lng(),
        };
      }
    } catch (error) {
      console.error('Hybrid geocoding error:', error);
    }

    return undefined;
  }

  async function getCenterPointFromAddress() {
    if (isCrawler || !addressForMapUi) {
      return undefined;
    }
    const addressParts = [
      addressForMapUi.neighbourhood,
      addressForMapUi.subDivision,
      addressForMapUi.provinceOrState,
    ].filter(Boolean) as string[];

    // Province/state abbreviations like "AL" are ambiguous to the geocoder.
    // When there is no city/neighbourhood to disambiguate, append the country
    // so "AL" becomes "AL, USA" and resolves to Alabama rather than a random
    // Alaskan locality that starts with "Al".
    if (addressParts.length <= 1 && addressForMapUi.country) {
      addressParts.push(addressForMapUi.country);
    }

    const formattedAddressSearchQuery = addressParts.join(', ') || addressForMapUi.country || '';
    
    try {
      const position = await getPositionFromAddress(formattedAddressSearchQuery);

      if (position?.latitude && position?.longitude) {
        listingParams.setFilter({
          ...listingParams.filter,
          latitude: position.latitude,
          longitude: position.longitude,
        });
        return ({ lat: position.latitude, lng: position.longitude });
      } else {
        console.log('[DEBUG map-center] geocoding returned no position, falling back to listingParams:', {
          lat: listingParams.filter.latitude,
          lng: listingParams.filter.longitude,
        });
        // Keep existing coordinates if geocoding fails
        listingParams.setFilter({
          ...listingParams.filter,
          latitude: listingParams.filter.latitude,
          longitude: listingParams.filter.longitude,
        });

        return ({ lat: listingParams.filter.latitude, lng: listingParams.filter.longitude });
      }
    } catch (error) {
      console.error('Geocoding error:', error);
      listingParams.setFilter({
        ...listingParams.filter,
        latitude: listingParams.filter.latitude,
        longitude: listingParams.filter.longitude,
      });

      return ({ lat: listingParams.filter.latitude, lng: listingParams.filter.longitude });
    }
  }

  async function getClustersWithinArea(slug: string, zoom: number, center: LatLngPoint, listingParams: ListingParams, bounds?: Bounds) {
    if (isCrawler) {
      return;
    }
    setDisplayablePins([]);
    setIsMapLoading(true);
    clustersAbortController?.current?.abort();
    clustersAbortController.current = new AbortController();
    let clusters: MapPageCluster[];
    const sort = listingParams.sort;
    const originalFilter: GeoSearchFilter = { ...cloneDeep(listingParams.filter) };

    try {
      const useMobilePrecision = window.innerWidth < IS_MOBILE_BREAKPOINT;
      const adjustedZoom = useMobilePrecision ? zoom : Math.floor(zoom);
      const getPrecisionFn = useMobilePrecision ? getGeohashPrecisionFromZoomMobile : getGeohashPrecisionFromZoom;
      const precision = useMobilePrecision ? getPrecisionFn(adjustedZoom) : getAreaClusterPrecisionFromZoom(zoom);
      const clustersResponse = await searchApi.searchClustersWithinArea(slug, precision as Precision, originalFilter, getSortBy(sort), clustersAbortController.current.signal, MAP_PAGE_CONSTANTS.DEFAULT_CLUSTER_DATA_SIZE, bounds);
      clusters = clustersResponse.clusters;
    } catch (error: unknown) {
      const err = error as { name?: string } | undefined;
      if (err?.name === 'AbortError'){
        console.debug('fetch clusters within boundary request was aborted');
      } else {
        console.error(error);
      }
      clusters = [];
    } finally {
      clustersAbortController.current = null;
    }
    // Optimization, only set clusters if they've changed, avoiding unnecessary rerenders
    setClusters(prevClusters => {
      if (prevClusters.length === clusters.length && 
          prevClusters.every((item, i) => item.key === clusters[i].key)) {
        return prevClusters; 
      }
      return clusters;
    });

    const consolidatedFilter = deepmerge<Filter>(originalFilter, {
      latitude: center.lat,
      longitude: center.lng,
      zoom,
    });
    listingParams.setFilter(consolidatedFilter as Filter);
    clustersAbortController.current = null;
    setIsMapLoading(false);
  }

  async function getPinsWithinArea(slug: string, zoom: number, center: LatLngPoint, listingParams: ListingParams, bounds?: Bounds, page: number = 1) {
    if (isCrawler || !bounds) {
      return;
    }
    setIsMapLoading(true);
    pinsAbortController?.current?.abort();
    pinsAbortController.current = new AbortController();
    const thisRequestId = ++pinsRequestId.current;
    const sort = listingParams.sort;
    // Match search_page_controller getPinsWithinBounds (same as searchPinsInBoundary / searchPinsWithinArea).
    const originalFilter: GeoSearchFilter = {
      ...cloneDeep(listingParams.filter),
      countryCode: filterByCountryCode,
    };
    const { maxPins, fullPinThreshold } = getMapPinLimits(window.innerWidth);

    // The server caps `offset + limit ≤ MAX_PIN_OFFSET`. Anything beyond returns
    // a terminal 400 — clamp on the client so the user can never request it.
    const safePage = Number.isFinite(page) && page >= 1 ? Math.floor(page) : 1;
    const maxReachablePage = Math.max(1, Math.floor(MAX_PIN_OFFSET / maxPins));
    const effectivePage = Math.min(safePage, maxReachablePage);
    const offset = (effectivePage - 1) * maxPins;

    try {
      if (!slug?.trim()) {
        setClusters([]);
        setDisplayablePins([]);
        setVisiblePinIds(null);
        setListingsData([]);
        setNextPageCursorState(null);
        setPaginationData(prev => ({ ...prev, count: 0, total: 1, page: 1, currentListings: 0, totalListings: 0 }));
        setHasLoadedBoundaryData(true);
        setHasLoadedPinData(true);
        return;
      }

      const flooredZoom = Math.floor(zoom);
      const useMobilePrecision = window.innerWidth < IS_MOBILE_BREAKPOINT;
      const getPrecisionFn = useMobilePrecision ? getGeohashPrecisionFromZoomMobile : getGeohashPrecisionFromZoom;
      const precision = getPrecisionFn(useMobilePrecision ? zoom : flooredZoom);

      const pinResponse = await searchApi.searchPinsWithinArea(
        slug,
        bounds,
        precision as Precision,
        originalFilter,
        getSortBy(sort),
        pinsAbortController.current.signal,
        maxPins,
        false,
        offset
      );

      if (thisRequestId !== pinsRequestId.current) return;

      const pins = assignPinDisplayModes(pinResponse.pins ?? [], fullPinThreshold);
      setClusters([]);
      setVisiblePinIds(null);
      setDisplayablePins(pins);

      const listingCards: ListingCardData[] = [];
      let currentListings = 0;
      for (const dp of pins) {
        currentListings += dp.pin.listingCount ?? 0;
        if (dp.pin.representative) {
          listingCards.push(new BoundaryListingCardData(dp.pin.representative));
        }
      }
      setListingsData(listingCards);
      setNextPageCursorState(null);
      // pageSize echoes the server's effective limit (after default/cap normalization).
      // Use it to clamp totalPages so the picker never offers a page that would 400.
      const effectivePageSize = pinResponse.pageSize || maxPins;
      const reachableTotalPages = Math.max(1, Math.floor(MAX_PIN_OFFSET / effectivePageSize));
      const totalPages = Math.max(1, Math.min(pinResponse.totalPages || 1, reachableTotalPages));
      setPaginationData(prev => ({
        page: effectivePage,
        size: prev.size,
        count: listingCards.length,
        total: totalPages,
        currentListings,
        totalListings: pinResponse.totalListings ?? currentListings,
      }));
      setHasLoadedBoundaryData(true);
      setHasLoadedPinData(true);
      hasFetchedInitialPin.current = true;
      // If the server clamped us (e.g. page=999 deep-link), reflect the clamped
      // page in state so the URL stays in sync via the page->URL effect.
      if (effectivePage !== safePage || effectivePage !== pinPageRef.current) {
        setPinPage(effectivePage);
      }
    } catch (error: unknown) {
      const err = error as { name?: string } | undefined;
      if (err?.name === 'AbortError') {
        console.debug('fetch pins within area request was aborted');
      } else {
        console.error(error);
      }
      if (thisRequestId === pinsRequestId.current) {
        setClusters([]);
        setDisplayablePins([]);
        setListingsData([]);
        setNextPageCursorState(null);
        setPaginationData(prev => ({ ...prev, count: 0, total: 1, currentListings: 0, totalListings: 0 }));
        setHasLoadedPinData(true);
      }
    } finally {
      pinsAbortController.current = null;
      if (thisRequestId === pinsRequestId.current) {
        const consolidatedFilter = deepmerge<Filter>(originalFilter, {
          latitude: center.lat,
          longitude: center.lng,
          zoom,
        });
        listingParams.setFilter(consolidatedFilter as Filter);
        setIsMapLoading(false);
      }
    }
  }

  const findSlugByIdForMap = useCallback((id: number): string | undefined => {
    if (useBuildingGroupedPins) {
      return displayablePins.find(dp => dp.pin.representative?.id === id)?.pin.representative?.slug;
    }
    return clusters
      .flatMap(cluster => cluster.listings)
      .find(listing => listing.id === id)?.slug;
  }, [useBuildingGroupedPins, displayablePins, clusters]);

  const favouriteDelegate: FavouriteDelegate = useMemo(() => ({
    isFavourite: function (id: number): boolean {
      return isSavedListing(findSlugByIdForMap(id), id);
    },
    toggleFavourite: function (id: number): boolean {
      if (!isAuthenticated) {
        openModal(LOGIN_REGISTRATION_MODAL, { callback: () => {
          addSavedListing({ listingId: id, isModal: true, source: PROPERTY_FAVOURITED_SOURCE_MAP_PIN });
        } });
        return false;
      }

      if (isSavedListing(findSlugByIdForMap(id), id)) {
        removeSavedListing(id, { source: PROPERTY_FAVOURITED_SOURCE_MAP_PIN });
        return false;
      }

      addSavedListing({ listingId: id, isModal: true, source: PROPERTY_FAVOURITED_SOURCE_MAP_PIN });
      return true;
    },
  }), [addSavedListing, isAuthenticated, isSavedListing, openModal, removeSavedListing, findSlugByIdForMap]);

  const handleMapListingClick = (listing: MapPageListing) => {
    const addressPathWithFallback = cleanDashedString(listing.addressUrlAbsolutePath || listing.listingUrlAbsolutePath);
    window.open(addressPathWithFallback, '_blank');
  };

  // Terms-of-use-required pins must show the terms modal first (the MapKit-rendered
  // callout root has no ModalContext, hence the dedicated callback). After the user
  // accepts, fall through to the normal new-tab behaviour used by the hybrid map.
  const handleMapTermsRequiredClick = (listing: MapPageListing) => {
    openModal(TERMS_OF_USE_MODAL, {
      providerId: listing.providerId,
      callback: () => {
        handleMapListingClick(listing);
      },
    });
  };

  const handleMapBoundingRegionChanged = (_oldBounds: Bounds | null, newBounds: Bounds) => {
    if (!areMapBoundsUsableForSearch(newBounds)) {
      return;
    }
    setMapState(prev => ({ ...prev, boundingRegion: newBounds }));
  };

  const handleMapZoomChanged = (_oldZoom: number, newZoom: number) => {
    if (!Number.isFinite(newZoom) || newZoom <= 0) {
      return;
    }
    setMapState(prev => ({ ...prev, zoom: newZoom }));
  };

  const fetchBuildingListings = useCallback(async (buildingKey: string, signal: AbortSignal): Promise<MapPageListing[]> => {
    if (!mapState.boundingRegion || mapState.zoom == null) return [];
    if (!listingsV2MapAreaSlug?.trim()) return [];
    const filterWithBuilding = { ...cloneDeep(listingParams.filter), countryCode: filterByCountryCode, buildingKey } as GeoSearchFilter & { buildingKey: string };
    const flooredZoom = Math.floor(mapState.zoom);
    const useMobilePrecision = window.innerWidth < IS_MOBILE_BREAKPOINT;
    const getPrecisionFn = useMobilePrecision ? getGeohashPrecisionFromZoomMobile : getGeohashPrecisionFromZoom;
    const precision = getPrecisionFn(useMobilePrecision ? mapState.zoom : flooredZoom);

    const pinResponse = await searchApi.searchPinsWithinArea(
      listingsV2MapAreaSlug,
      mapState.boundingRegion,
      precision as Precision,
      filterWithBuilding,
      getSortBy(listingParams.sort),
      signal,
      1,
      true
    );
    const listings = pinResponse.pins[0]?.listings ?? [];
    return listings.map(l => boundaryListingToMapPageListing(l));
  }, [mapState.boundingRegion, mapState.zoom, listingParams, searchApi, listingsV2MapAreaSlug, filterByCountryCode]);

  const refreshPageDataRef = useRef(refreshPageData);
  refreshPageDataRef.current = refreshPageData;

  const refreshPageDataDebounced = useMemo(
    () => createDelayedExecution((...args: Parameters<typeof refreshPageData>) => refreshPageDataRef.current(...args), HYBRID_MAP_REFRESH_DEBOUNCE_MS),
    []
  );

  const fetchPolygonData = async () => {
    try {
      if (!addressForMapUi?.slug) {
        return '';
      }
      const response = await fetchAreaPolygons({
        slug: addressForMapUi.slug,
      });
      
      if (response.data && response.data.length > 0) {
        const wkt = response.data[0].polygon;
        return wkt;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Error fetching area polygon:', error);
      return '';
    }
  };

  const { data: areaPolygonWkt = '' } = useQuery<string>({
    queryKey: ['area-polygon-coordinates', addressForMapUi?.slug],
    queryFn: () => fetchPolygonData(),
    enabled: Boolean(addressForMapUi?.slug),
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  const { data: mapCenterPoint, isLoading: isMapCenterPointLoading, isError: isMapCenterPointError, error: mapCenterPointError } = useQuery<LatLngPoint>({
    queryKey: ['map-center-point', addressForMapUi?.slug],
    queryFn: () => getCenterPointFromAddress(),
    enabled: Boolean(addressForMapUi?.slug),
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    refreshPageDataDebounced.schedule();
    return () => {
      refreshPageDataDebounced.cancel();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapState.boundingRegion, mapState.zoom]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    purgeAndRefreshPageData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return (<PageView
    ref={mapRef}
    useLayoutV2={useLayoutV2}
    electedAddress={addressForMapUi ?? electedAddress}
    listingParams={listingParams}
    listings={listingsForGrid}
    pagination={paginationData}
    sort={sourceSort}
    heading={heading}
    citySlug={citySlug}
    breadcrumbs={breadcrumbs}
    listingsContainerRef={listingsContainerRef}
    areaPolygonWkt={areaPolygonWkt}
    areaName={areaName}
    areaBlurb={areaBlurb}
    areaBlurbHeading={areaBlurbHeading}
    areaOverviewTitle={areaOverviewTitle}
    areaNamedContent={areaNamedContent}
    areaInsightsData={areaInsightsData}
    internalLinks={internalLinks}
    internalLinksHeading={internalLinksHeading}
    seoLinks={seoLinks}
    noListingsInAreaMessage={noListingsInAreaMessage}
    hasNoListingsInArea={isFallbackAreaPage && paginationData.count === 0}
    missingAddressMessage={missingAddressMessage}
    expandGuidesByDefault={expandGuidesByDefault}
    showGuides={showGuides}
    showDisclaimer={showDisclaimer}
    onPrevPage={handlePrevPage}
    onNextPage={handleNextPage}
    setPageNumber={handlePinPageNumberChange}
    paginationMode={useBuildingGroupedPins && !isProvinceOrCountryAddress ? PaginationMode.NUMBERED : PaginationMode.PREVNEXT}
    onSortChanged={onSortChanged}
    onMobileFilterButtonClick={openSavedSearchFiltersModal}
    onValueChange={onFiltersChanged}
    onSaveSearchButtonClick={onSaveSearchButtonClick}
    onLocationSearchClick={onSearchResultClick}
    onMapIconClick={handleMapIconClick}
    onMoreButtonClick={onMoreButtonClick}
    showFilterDeprecationWarning={showFilterDeprecationWarning}
    showNoImageListingsFilterWarning={showNoImageListingsFilterWarning}
    onDeprecationWarningButtonClick={handleDeprecationWarningButtonClicked}
    onNoImageListingsFilterWarningClose={handleNoImageListingsFilterWarningClose}
    trackMapCardClick={trackMapCardClick}
    showsMyLinkMyLeadCreate={showsMyLinkMyLeadCreate}
    mapCenterPoint={mapCenterPoint}
    mapZoom={mapZoom}
    compliancyDelegate={compliancyDelegate}
    favouriteDelegate={favouriteDelegate}
    clusteredListings={clusters}
    displayablePins={useBuildingGroupedPins ? displayablePins : undefined}
    fetchBuildingListings={useBuildingGroupedPins ? fetchBuildingListings : undefined}
    useBuildingGroupedPins={useBuildingGroupedPins}
    onVisiblePinIdsChanged={useBuildingGroupedPins ? handleVisiblePinIdsChanged : undefined}
    isMapLoading={isMapLoading}
    isListingsLoading={isListingsLoading}
    onMapBoundingRegionChanged={handleMapBoundingRegionChanged}
    onMapZoomChanged={handleMapZoomChanged}
    onListingClick={handleMapListingClick}
    onListingAddressClick={handleMapListingClick}
    onTermsRequiredClick={handleMapTermsRequiredClick}
    onSingleListingClusterClick={handleMapListingClick}
    isProvinceOrCountryAddress={isProvinceOrCountryAddress}
    isMobileListView={isMobileListView}
    setIsMobileListView={setIsMobileListView}
    isCrawler={isCrawler}
    mapkitSnapshotUrl={mapkitSnapshotUrl}
    isMapCenterPointLoading={isMapCenterPointLoading}
    isMapCenterPointError={isMapCenterPointError}
    mapCenterPointError={mapCenterPointError}
    onSidePanelExpandedChange={setIsHybridDesktopListFullWidth}
  />);
};


//#region Helper functions
function generateAreaOverviewTitle(address: SingleAddress) {
  if (address.addressType === AddressType.ADDRESS_TYPE_PROVINCE_OR_STATE) {
    return isUsStateCode(address.provinceOrState?.toUpperCase() as ProvinceOrStateCode) ? 'State Guide' : 'Province Guide';
  } else if (address.addressType === AddressType.ADDRESS_TYPE_NEIGHBOURHOOD) {
    return 'Neighbourhood Guide';
  } else {
    return 'City Guide';
  }
}

//#endregion
export default HybridPageController;

export { HybridPageController };
